// @flow

import {
  PASSWORD_FORM_ON_CHANGE,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
} from '../constants'

type InitialState = {
  account: {
    password: string,
    newPassword: string,
  },
  repeatNewPassword: string,
  updateSuccess: boolean | string,
  error: string,
}

const initialState = {
  account: {
    password: '',
    newPassword: ''
  },
  repeatNewPassword: '',
  error: '',
  updateSuccess: '',
}

function changePassword(state: InitialState = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case PASSWORD_FORM_ON_CHANGE:
      return {
        ...state,
        account: action.payload.account,
        repeatNewPassword: action.payload.repeatNewPassword
      }
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        updateSuccess: action.payload,
        account: {
          password: '',
          newPassword: ''
        },
        repeatNewPassword: '',
      }
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default changePassword



// WEBPACK FOOTER //
// ./src/modules/changePassword.js